// utils/translations/QuestionFooterTranslations.js

const translations = {
    fr: {
      confirmQuitText: "Voulez-vous vraiment abandonner la partie en cours ?",
      confirmButton: "Confirmer",
      cancelButton: "Annuler"
    },
    en: {
      confirmQuitText: "Do you really want to abandon the current game?",
      confirmButton: "Confirm",
      cancelButton: "Cancel"
    },
    de: {
      confirmQuitText: "Möchten Sie das laufende Spiel wirklich beenden?",
      confirmButton: "Bestätigen",
      cancelButton: "Abbrechen"
    },
    es: {
      confirmQuitText: "¿Realmente quieres abandonar la partida actual?",
      confirmButton: "Confirmar",
      cancelButton: "Cancelar"
    },
    it: {
      confirmQuitText: "Vuoi davvero abbandonare la partita in corso?",
      confirmButton: "Conferma",
      cancelButton: "Annulla"
    }
  };
  
  export default translations;
  